// A resolve/reopen/send mutation and the queue's summary poll live in
// separate component trees (CustomerWorkspace vs. QueueList), with no shared
// state between them — this bus is how one tells the other "refetch now"
// instead of waiting out useChatPoll's interval.
type Listener = () => void;
const listeners = new Set<Listener>();

export function notifyChatSummariesStale(): void {
  for (const listener of listeners) {
    listener();
  }
}

export function subscribeChatSummariesStale(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
